import { AuthView } from 'modules/auth/common/views/AuthView';

import { TwoFactorForm, TwoFactorFormProps } from '../components/TwoFactorForm';

interface Props extends TwoFactorFormProps {}

export const TwoFactorConnectionView = ({ ...formProps }: Props) => (
  <AuthView>
    <TwoFactorForm {...formProps} />
  </AuthView>
);
